import(/* webpackMode: "eager" */ "/home/runner/_work/client_wastewizer_com/client_wastewizer_com/apps/client-app/src/app/loading.tsx");
